import React from 'react'

export default function header() {
  return (
    <>
     {/* NAVBAR */}
      <header className="navbar">
        <div className="logo">
          <div className="logo-icon">V</div>
          <div>
            <h1>MyWebsite</h1>
            <p>Build. Ship. Grow.</p>
          </div>
        </div>
        <nav>
          <a href="#features">Features</a>
          <a href="#pricing">Pricing</a>
          <a href="#about">About</a>
          <button>Sign in</button>
        </nav>
      </header>
</>
  )
}
